import Vue from 'vue'
import Vuex from 'vuex'
import { stat } from 'fs';

Vue.use(Vuex)

// 生成模拟的微信id，区分用户
function generateMockOpenid () {
  const small = 'abcdefghijklmnopqrstuvwxyz';
  const big = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const number = '0123456789';
  const symbol = ',.!?@#$%';
  
  let str = ''
  let result = ''
  let types = 'smallnumber'
  let length = 12

  switch (types) {
    case 'small':
      str = small;
      break;
    case 'smallnumber':
      str = small + number;
      break;
    default:
      str = small;
  }

  // 根据字符长度，循环n次，生成随机字符
  for (let i = 0; i < length; i++) {
    result += str[Math.floor(Math.random() * str.length)]
  }

  return 'wx' + result;
}

const n = window.navigator
const u = window.navigator ? window.navigator.userAgent : ''

let mockOpenid = localStorage.mockOpenid
if (!mockOpenid) {
  localStorage.mockOpenid = mockOpenid = generateMockOpenid()
}

export default new Vuex.Store({
  // 全部的页面状态都在这，当重玩一次的时候，重置这里的状态即可
  state: {
    // 微信分享初始化的链接
    jsUrl: location.href,

    // 是否有抽奖的版本，打包的时候是两个链接
    hasPrizeVersion: true,

    // 接口域名，方便开发调试
    hostname: 'https://share.m.china.com.cn',
    // hostname: location.protocol + '//' + location.hostname + ':3000',

    // 是否手机
    isMobile: (u.indexOf('Mobi') > -1 || u.indexOf('iPh') > -1 || u.indexOf('480') > -1) && n.platform.match(/MacIntel/ig) === null,
    // 是否安卓
    isAndroid: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1,
    // 是否ios
    isIOS: u.indexOf('like Mac OS X') > -1,
    // 是否微信
    isWeixin: u.indexOf('MicroMessenger') > -1,
    // 是否Safari浏览器
    isSafari: u.indexOf('Safari') > -1,

    homeVideoCanplay: false,
    homeVideoCurrentTime: 0,

    // 当前页，默认首页
    pageActive: 'home',
    // 前一页，默认首页
    pageBefore: 'home',
    // 上传图片的base64数据
    base64: '',
    // 百度和七牛的token
    tokens: {},

    // 匹配好的海报数据，
    result: [
      // 示例数据
      // {
      //   title: '',
      //   content: '',
      //   value: 0
      // }
    ],

    // home页或其它页面是否渲染完成
    pageReady: false,

    // 默认的分享数据
    shareData: {
      url: '',
      title: '“扫扫”身边物，报告亮点来！读它读它读它！',
      desc: '政府工作报告藏在你身边',
      image: location.protocol + '//' + location.host +'/plug/20200303/images/share.jpg'
    },

    shareId: '',
    wxUser: {
      openid: mockOpenid,
      nickname: '你',
      headimgurl: './images/default.jpg'
      // headimgurl: 'https://m.china.com.cn/plug/20200304/default.jpg'
    } // openid, nickname, headimgurl
  },
  mutations: {
    setWxJsUrl (state, url) {
      state.jsUrl = url
    },
    setWxShareUrl (state, url) {
      state.shareData.url = url
    },

    // 修改请求链接的域名
    setHost (state, data) {
      state.hostname = data.hostname
    },

    setHomeVideoCanplay (state, data) {
      state.homeVideoCanplay = data
    },

    setHomeVideoCurrentTime (state, data) {
      state.homeVideoCurrentTime = data
    },

    // 获取上传图片的base64数据
    setBase64 (state, base64) {
      state.base64 = base64
    },

    // 清空base64数据
    clearBase64 (state) {
      state.base64 = ''
    },

    // 设置全局的token
    setToken (state, data) {
      state.tokens.baiduToken = data.bdtoken
      state.tokens.qiniuToken = data.qntoken
    },

    // 设置识别结果
    setResult (state, data) {
      state.result = data
    },

    // 清空识别结果，为第二次做准备
    clearResult (state) {
      state.result = []
    },

    // 储存shareId
    setShareId (state, shareId) {
      state.shareId = shareId
    },

    // 清空shareId
    clearShareId (state) {
      state.shareId = ''
    },

    // 微信授权，获取了用户信息
    setWxUser (state, userInfo) {
      state.wxUser.openid = userInfo.openid
      state.wxUser.nickname = userInfo.nickname
      state.wxUser.headimgurl = userInfo.headimgurl
    },

    // 路由页面渲染完成
    setPageReady (state) {
      state.pageReady = true
    }
  },
  actions: {
  },
  modules: {
  }
})
